import { HttpStatusCode } from 'axios';

/**
 * バックエンド応答
 */
export class BackendResponse {
  /**
   * コンストラクタ
   *
   * @param {AxiosResponse} res HTTPレスポンス
   */
  constructor(res) {
    res = res || {};

    // ステータス
    this.status = res.status || null;
    this.statusText = BackendResponse.statusText(res) || '';

    // 正常判定
    this.ok = res.status === HttpStatusCode.Ok;

    // ヘッダー
    this.headers = res.headers || {};

    // 応答ボディ
    this.body = res.data || null;

    // 詳細メッセージ
    const details = res.data?.detailMessages;
    this.messages = Array.isArray(details) ? details : [];
  }

  /**
   * レスポンス解析
   *
   * @param showMessage メッセージ表示関数
   * @return このオブジェクト
   */
  parse = (showMessage) => {

    // 応答ボディにメッセージがあればダイアログ表示
    const message = this.body?.message;
    if (message && showMessage) {
      showMessage({ message });
    }

    // 400応答でメッセージがない場合はダイアログ表示
    if (this.status === HttpStatusCode.BadRequest &&
        this.messages.length === 0) {
      this.messages.push({ id: 'BFY000049E'  });  // 入力誤り
    }
    return this;
  };

  /**
   * レスポンスボディを配列として取得
   *
   * @param {object} options 解析オプション
   *      - {number} max 最大件数
   *      - {string} error 最大件数超過時のメッセージID
   *      - {string} empty ゼロ件応答時のメッセージID
   * @return {object[]} レスポンスボディ(配列)
   */
  parseBodyAsArray = (options) => {
    const max = options?.max || 0;
    const error = options?.error ?? 'BFY000015E';
    const empty = options?.empty ?? 'BFY000016E';

    // ボディが配列でなければ空の配列を応答
    const bodyArray = Array.isArray(this.body)
        ? this.body
        : [];

    // 最大件数を超えている場合は切り詰める
    if (typeof max === 'number' && 0 < max && max <= bodyArray.length) {
      bodyArray.length = max;

      // 上限超過メッセージ
      this.messages.push({ id: error, values: [ max ] });
    }

    // ゼロ件メッセージ
    if (empty && bodyArray.length === 0) {
      this.messages.push({ id: empty });
    }

    // ボディ配列を返す
    return bodyArray;
  }

  /**
   * HTTPステータス文字列
   *
   * @param {AxiosResponse} res HTTPレスポンス
   * @return {string} ステータス文字列
   *      - レスポンスのステータステキスト or
   *      - ステータスコードから生成した文字列
   */
  static statusText(res) {
    if (res.statusText) {
      return res.statusText;
    }
    return HttpStatusCode[res.status]
        ?.split(/(?=[A-Z])/)
        ?.join(' ');
  }
}

// デフォルトエクスポート
export default BackendResponse;
